import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    updateChannel = new Subject();
    detailChannel = new Subject();
    repository = new UpdateRepository()
    echelonChannel = new Subject();
    positionStatusChannel = new Subject();
    positionChannel = new Subject();
    workUnitChannel = new Subject();
    signatoryChannel = new Subject();

    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})
    }

    fetchEchelon = async (query) => {
        this.echelonChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchEselon(query).then((result) => {
            this.echelonChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.echelonChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchPositionStatus = async (query) => {
        this.positionStatusChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPositionStatus(query).then((result) => {
            this.positionStatusChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.positionStatusChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchPosition = async (query) => {
        this.positionChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPosition(query).then((result) => {
            this.positionChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.positionChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchWorkUnit = async (query) => {
        this.workUnitChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchWorkUnit(query).then((result) => {
            this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSignatory = async (query) => {
        this.signatoryChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSignatoryOfficial(query).then((result) => {
            this.signatoryChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.signatoryChannel.next({status: apiResponse.ERROR, data: error})
        })
    }


    fetchUpdate = async (query) => {
        this.updateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchUpdate(query).then((result) => {
            this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.updateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default UpdateBloc